// extracted by mini-css-extract-plugin
export default {"inputNumber":"InputPrice_inputNumber__56B4p","fullWidthInput":"InputPrice_fullWidthInput__lybUf"};